module.exports = __webpack_public_path__ + "img/a7.60664435.png";